module.exports = __webpack_public_path__ + "files/2b369f7e25ab594061bec068c1b68172.png";